




















import { bemBuilder } from "@/v2/util/bem-builder";
import {
  defineComponent,
  PropType,
  ref,
  computed,
  watch,
} from "@vue/composition-api";
import dayjs from "dayjs";
// @ts-ignore
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";

const css = bemBuilder("atom-datepicker");

export default defineComponent({
  name: "AtomDatepicker",
  components: {
    VueDatePicker,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    minDate: {
      type: String,
      default: "",
    },
    maxDate: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    onInput: {
      type: Function as PropType<(date?: string) => void>,
      required: true,
    },
  },
  setup(props) {
    const model = ref<string>(dayjs().add(1, "day").format("YYYY-MM-DD"));

    const pickerEl = ref<HTMLDivElement>();

    function onChange() {
      props.onInput(model.value);
    }

    watch(
      () => props.value,
      (val) => {
        if (val) {
          model.value = val;
        }
      },
      {
        immediate: true,
      }
    );

    return {
      css,
      model,
      onChange,
      pickerEl,
    };
  },
});
